"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/* eslint-disable react/no-find-dom-node */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_react_1 = require("mobx-react");

var react_1 = __importStar(require("react"));

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var react_dom_1 = require("react-dom");

var react_dnd_1 = require("react-dnd");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var ColorUtil_1 = __importDefault(require("../../utils/ColorUtil"));
/** Methods triggered when the component is dragged */


var dragSourceSpec = {
  beginDrag: function beginDrag(props) {
    return {
      ruleIndex: props.ruleIndex
    };
  },
  endDrag: function endDrag(props, monitor) {
    if (monitor.didDrop()) {
      var droppedResult = monitor.getDropResult();

      if (!props || !droppedResult) {
        return;
      }

      var currentIndex = droppedResult.currentIndex,
          newIndex = droppedResult.newIndex;

      if (currentIndex > newIndex) {
        props.onRowMove(currentIndex, newIndex);
      } else if (currentIndex < newIndex) {
        props.onRowMove(currentIndex, newIndex - 1);
      }
    }
  }
};
/** Props appended to the drag source **/

var connectDS = function connectDS(connect) {
  return {
    connectDragSource: connect.dragSource()
  };
};
/** Summary view for unexpanded RuleListItems **/


var DragSourceUnexpandedRuleComponent =
/** @class */
function (_super) {
  __extends(DragSourceUnexpandedRuleComponent, _super);

  function DragSourceUnexpandedRuleComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.multiLineNodeRef = react_1.default.createRef();
    return _this;
  }

  DragSourceUnexpandedRuleComponent.prototype.componentDidUpdate = function () {
    if (this.multiLineNodeRef.current) {
      this.multiLineNodeRef.current.setState({
        truncatedText: this._getLabel()
      });
    }
  };

  DragSourceUnexpandedRuleComponent.prototype.render = function () {
    var _a = this.props,
        connectDragSource = _a.connectDragSource,
        fontColor = _a.fontColor,
        selectedIcon = _a.selectedIcon,
        icons = _a.icons,
        backgroundColor = _a.backgroundColor;
    var style = ColorUtil_1.default.getColorStyle(fontColor, backgroundColor || 'white', null);
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-unexpanded-rule'),
      ref: function ref(instance) {
        var node = react_dom_1.findDOMNode(instance);
        connectDragSource(node);
      }
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-drag-handler'
    }, react_1.default.createElement(ca_ui_toolkit_1.SVGIcon, {
      icon: icons.getIcon('draggable_16'),
      size: 'normal',
      verticalAlign: 'middle',
      focusable: true,
      ariaLabelledby: StringResources_1.default.get('conditionalFormattingMove')
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-rule-label'
    }, react_1.default.createElement(ca_ui_toolkit_1.Multilinetruncatedtext, {
      ref: this.multiLineNodeRef,
      value: this._getLabel(),
      style: {
        fontWeight: 'bold',
        width: '100%',
        'letter-spacing': '-0.01px'
      },
      numLines: 3
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-rule-value',
      style: style
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: '123',
      ellipsis: true,
      style: {
        color: fontColor
      }
    }), selectedIcon && react_1.default.createElement(ca_ui_toolkit_1.SVGIcon, {
      iconId: selectedIcon.iconId,
      verticalAlign: 'middle',
      focusable: false,
      style: {
        color: fontColor
      }
    })));
  };

  DragSourceUnexpandedRuleComponent.prototype._getLabel = function () {
    var label = this.props.label;
    return label && label.length ? label : StringResources_1.default.get('conditionalFormattingInvalidRule');
  };

  return DragSourceUnexpandedRuleComponent;
}(react_1.Component);

var ObserverUnexpandedRuleComponent = mobx_react_1.observer(DragSourceUnexpandedRuleComponent);
var UnexpandedRuleComponent = react_dnd_1.DragSource('Rules', dragSourceSpec, connectDS)(ObserverUnexpandedRuleComponent);
exports.default = UnexpandedRuleComponent;
